'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var prosemirrorHistory = require('prosemirror-history');
var keymap = _interopDefault(require('../keymap/index.js'));

// The amount of undoable events available in a given state.

function undoDepth(state) {
  return prosemirrorHistory.undoDepth(state);
} // :: (EditorState) → number
// The amount of redoable events available in a given editor state.

function redoDepth(state) {
  return prosemirrorHistory.redoDepth(state);
}
function redo(state, dispatch, view, trigger) {
  const res = prosemirrorHistory.redo(state, dispatch, view);
  if (typeof trigger === 'function') trigger('stateChanged');
  return res;
}
function undo(state, dispatch, view, trigger) {
  const res = prosemirrorHistory.undo(state, dispatch, view);
  if (typeof trigger === 'function') trigger('stateChanged');
  return res;
}

class HistoryModule {
  constructor() {
    this.name = 'history';
    this.commands = {
      undo: () => undo,
      redo: () => redo
    };
    this.utils = {
      undoDepth,
      redoDepth
    };
    this.plugins = [keymap({
      'Mod-z': undo,
      'Mod-y': redo,
      'Shift-Mod-z': redo,
      'Mod-Z': undo,
      'Mod-Y': redo,
      'Shift-Mod-Z': redo
    }), prosemirrorHistory.history()];
  }

}
HistoryModule.moduleName = 'history';

exports.HistoryModule = HistoryModule;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/@mtfe/citadel-editor/lib/history/index.js